import { useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { delay, removeLocalStorageItem } from '@/utils';
import { Menu, MenuItem } from '@szhsin/react-menu';
import Cookies from 'js-cookie';

import { ROUTE_ADMIN_MANAGE_ACCOUNT, TOKEN_ADMIN } from '@/utils/constants';
import useUserStore, { useModalLoadingStore } from '@/utils/store/store';
import SvgArrowDown from '@/components/common/Icons/ArrowDown';
import SvgUserCircle from '@/components/common/Icons/UserCircle';
import { useGetDependencyById } from '@/components/views/Admin/private/Dependencies/hooks/useGetDependencyById';

const MenuUser = () => {
  const router = useRouter();
  const { user } = useUserStore();
  const { showLoading } = useModalLoadingStore();
  const { remove: removeUser, saveDependencyId, saveDependencyUser } = useUserStore();

  const dependencyId = useUserStore((state) => state.dependencyId);
  const { data } = useGetDependencyById({ dependencyId: dependencyId || '' });

  useEffect(() => {
    if (data?.dependency) {
      saveDependencyUser(data.dependency);
    }
  }, [data?.dependency, saveDependencyUser]);

  const logout = async () => {
    showLoading(true);
    saveDependencyId(undefined);
    saveDependencyUser(undefined);
    removeUser();
    removeLocalStorageItem('userauth');
    Cookies.remove(TOKEN_ADMIN);
    await delay(1000);
    await router.push('/admin');
    showLoading(false);
  };

  return (
    <Menu
      gap={-5}
      menuClassName="flex flex-col body-text1 rounded bg-white text-tundora min-w-[120px] shadow animate-fade-in-down z-dropdown w-[250px] shadow-md"
      menuButton={
        <div className="me-4 flex w-[250px] cursor-pointer items-center justify-between gap-3 rounded-md px-4 py-1 transition-all hover:bg-blueDark">
          <div className="flex flex-row items-center gap-x-3 overflow-hidden">
            <div className="max-w-7">
              <SvgUserCircle />
            </div>

            <div className="flex w-full flex-col text-white">
              <label className="cursor-pointer select-none truncate font-workSans text-[14px] font-semibold capitalize leading-[16.8px]">
                {user?.fullName}
              </label>
              <label className="line-clamp-1 cursor-pointer select-none truncate font-workSans text-[14px] font-normal capitalize leading-[16.8px]">
                {dependencyId ? (data?.dependency?.name ?? '').toLowerCase() : ''}
              </label>
            </div>
          </div>
          <div className="size-3">
            <SvgArrowDown />
          </div>
        </div>
      }
    >
      <MenuItem className={'bg-white'}>
        <Link
          className="flex h-[40px] flex-row items-center gap-x-2 px-4 transition-all hover:bg-gray-200"
          href={ROUTE_ADMIN_MANAGE_ACCOUNT}
        >
          Editar mis datos
        </Link>
      </MenuItem>

      <MenuItem className={'bg-white'}>
        <a
          className="flex h-[40px] cursor-pointer flex-row items-center gap-x-2 px-4 transition-all hover:bg-gray-200"
          onClick={() => void logout()}
        >
          {'Cerrar sesión'}
        </a>
      </MenuItem>
    </Menu>
  );
};

export default MenuUser;
